"use client";

import React from "react";
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

import { ChevronLeft, ChevronRight } from "lucide-react";

const stats = [
  { value: "700+", label: "Internships/OJL Offered" },
  { value: "100+", label: "Companies visited from 11 different Industries" },
  { value: "250+", label: "Offers Made" },
  { value: "9LPA", label: "Highest Package" },
  { value: "95%", label: "of eligible students were placed" },
];

const faculty = [
  {
    name: "Megha Sood",
    role: "Manager - Strategic Partnerships & Alliances (Founder's Office)",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Megha-Sood.jpg",
  },
  {
    name: "Ms Chimi Uden Bhutia",
    role: "Assistant Manager Center for Career Development & Placement",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Ms-Chimi-Uden-Bhutia.jpg",
  },
  {
    name: "Prayash Giri",
    role: "Placements Senior Executive",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/Placement/prayash-giri.webp",
  },
  {
    name: "Shanthini S",
    role: "Placements Officer Placements & Career Services",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Shanthini-S.jpg",
  },
  {
    name: "Jonty Mazumder",
    role: "Placements Senior Executive",
    image:
      "https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Jonty-Mazumder.jpg",
  },
];

export default function Ccdp() {
  const [prevEl, setPrevEl] = React.useState(null);
  const [nextEl, setNextEl] = React.useState(null);

  return (
    <section className="relative overflow-hidden bg-[#081E2D]">
      {/* Gradient Background Overlay */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#081E2D] via-[#081E2D] to-[#0B3D59] opacity-50" />

      <div className="page-container relative z-10 mx-auto pt-10">
        {/* Title Section */}
        <div className="w-full text-left mb-12 md:mb-16">
          <h2
            className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-6"
            style={{ fontFamily: "saans-bold" }}
          >
            Centre For Career Development & Placement (CCDP)
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-white/90 leading-relaxed w-full max-w-5xl">
            The Centre For Career Development & Placement (CCDP) at Medhavi
            Skills University actively connects students with industry through
            structured On-the-Job Learning and placements. MSU learners have
            progressed into roles with Hyatt, Sterling Holidays, Flipkart,
            Codeyoung, Krutanic Solutions, Reliance and Club Mahindra,
            reflecting strong employer partnerships, sectoral diversity and
            consistent focus on career-ready outcomes across multiple emerging
            industry sectors.
          </p>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-4 mb-16 md:mb-24">
          {stats.map((stat, idx) => (
            <div
              key={idx}
              className="flex flex-col border-l border-white/10 pl-4 md:pl-6 first:border-l-0"
            >
              <span
                className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#FFA201] mb-2"
                style={{ fontFamily: "saans-bold" }}
              >
                {stat.value}
              </span>
              <span className="text-xs md:text-sm text-white/80 leading-tight max-w-[200px]">
                {stat.label}
              </span>
            </div>
          ))}
        </div>

        {/* <div className="w-full">
          <div className="flex items-center justify-between mb-8 md:mb-12">
            <h3
              className="text-2xl sm:text-3xl font-bold text-white"
              style={{ fontFamily: "saans-bold" }}
            >
              Placement Team
            </h3>

            <div className="flex gap-3">
              <button
                ref={(node) => setPrevEl(node)}
                className="cursor-pointer bg-white/10 border border-white/20 rounded-full p-2 shadow-sm hover:bg-white/20 transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
                aria-label="Previous"
              >
                <ChevronLeft className="w-5 h-5 text-white" />
              </button>
              <button
                ref={(node) => setNextEl(node)}
                className="cursor-pointer bg-white/10 border border-white/20 rounded-full p-2 shadow-sm hover:bg-white/20 transition-colors disabled:opacity-30 disabled:cursor-not-allowed"
                aria-label="Next"
              >
                <ChevronRight className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>

          <Swiper
            modules={[Navigation, Autoplay]}
            spaceBetween={20}
            slidesPerView={1.2}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            navigation={{
              prevEl,
              nextEl,
            }}
            onBeforeInit={(swiper) => {
              swiper.params.navigation.prevEl = prevEl;
              swiper.params.navigation.nextEl = nextEl;
            }}
            breakpoints={{
              640: { slidesPerView: 2.2 },
              1024: { slidesPerView: 3.2 },
              1280: { slidesPerView: 4 },
            }}
            className="faculty-swiper"
          >
            {faculty.map((member, idx) => (
              <SwiperSlide key={idx} className="h-auto">
                <div className="bg-white overflow-hidden h-full flex flex-col shadow-sm">
                  <div className="relative aspect-[4/3] w-full shrink-0">
                    <Image
                      src={member.image}
                      alt={member.name}
                      fill
                      className="object-cover object-top"
                    />
                  </div>
                  <div className="p-4 md:p-3 flex-1 flex flex-col justify-start min-h-[85px]">
                    <h4
                      className="font-bold text-[#081E2D] text-sm md:text-base"
                      style={{ fontFamily: "saans-bold" }}
                    >
                      {member.name}
                    </h4>
                    <p className="text-xs md:text-sm text-gray-600 leading-tight">
                      {member.role}
                    </p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-20 mt-16 md:mt-24 items-center">
          <div className="flex flex-col justify-center">
            <h3
              className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white sm:mb-4"
            >
              <span className="text-[#0B6EA8] block" style={{ fontFamily: "saans-bold" }}>At Medhavi,</span>
              <span className="text-white" style={{ fontFamily: "saans-bold" }}> 
                Our students support <br></br> placements to take ownership{" "}
              </span>
              <span className="text-[#FFA201]" style={{ fontFamily: "saans-bold" }}>beyond classrooms</span>
            </h3>
            <p
              className="text-base md:text-lg text-white/80 leading-relaxed font-light"
              style={{ fontFamily: "saans-regular" }}
            >
              <span>Our students actively support placements, building responsibility, collaboration and required exposure.</span> 
            </p>
          </div>

          <div className="relative aspect-[16/10] w-full overflow-hidden shadow-2xl border-4 border-white/10">
            <Image
              src="https://cdn.msu.edu.in/msu-reavamp/images/Placement/placement-support.jpg"
              alt="Medhavi Students Team"
              fill
              className="object-cover"
            />
          </div>
        </div> */}
      </div>
    </section>
  );
}
